export const Actions = {
  CREATE: "create",
  MODIFY: "modify",
  EMPTY: "",
  CLOSE: "close",
  CHILD: "child"
};
